import React from 'react';
import { cn } from '@shared/lib/utils';

interface SidebarCollapseIconProps {
  collapsed: boolean;
  className?: string;
}

function AnglesLeftSvg({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M13.5 5.5L8.5 12l5 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 5.5L14.5 12l5 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AnglesRightSvg({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M10.5 5.5L15.5 12l-5 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 5.5L9.5 12l-5 6.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SidebarCollapseIcon({
  collapsed,
  className,
}: SidebarCollapseIconProps): React.ReactElement {
  return (
    <span className={cn('relative block size-6 shrink-0', className)} aria-hidden>
      <AnglesLeftSvg
        className={cn(
          'absolute inset-0 size-6 transition-opacity duration-normal ease-standard',
          collapsed ? 'opacity-0' : 'opacity-100'
        )}
      />
      <AnglesRightSvg
        className={cn(
          'absolute inset-0 size-6 transition-opacity duration-normal ease-standard',
          collapsed ? 'opacity-100' : 'opacity-0'
        )}
      />
    </span>
  );
}
